import { Button } from '@chakra-ui/react'
import { useFormContext } from 'commons/config/form'
import { isXpayType, PaymentTypes } from 'commons/constants/paymentTypes'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import { useTranslation } from 'react-i18next'

export const ValidationButton = ({
	isFromMoneyPot = false,
	isPaymentPending = false
}: {
	isFromMoneyPot?: boolean
	isPaymentPending?: boolean
}) => {
	const { t } = useTranslation()
	const form = useFormContext()

	const submit = () => {
		form.handleSubmit({ submitAction: 'continue' })
	}

	return (
		<>
			{form.Subscribe({
				selector: (state) => ({
					isSubmitting: state.isSubmitting,
					amount: state.values.amount,
					paymentType: state.values.paymentType
				}),
				children: ({ isSubmitting, amount, paymentType }) => {
					// Format the amount with currency
					const formattedAmount = amount ? t('phone_form.amount_format', { value: amount }) : ''
					// We need this syntax to avoid linter issue
					let buttonText = `${t('phone_form.send')} ${formattedAmount}`
					if (isFromMoneyPot && paymentType === PaymentTypes.LYDIA) {
						buttonText = t('phone_form.cta_pay_with_lydia')
					} else if (isFromMoneyPot && paymentType === PaymentTypes.CARD) {
						buttonText = t('phone_form.cta_pay_with_card')
					} else if (isFromMoneyPot && isXpayType(paymentType)) {
						buttonText = t('phone_form.cta_pay_with_xpay')
					}

					return (
						<Button
							type='submit'
							fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
							fontWeight={700}
							onClick={submit}
							disabled={isSubmitting || isPaymentPending}
							borderTopRadius='sm'
							borderBottomRadius='xl'
							w='full'
							py={8}
							px={6}
							bg={BgColors.OPPOSITE_Z3}
							color={TextColors.OPPOSITE_PRIMARY}
							_hover={{
								bg: BgColors.OPPOSITE_Z2,
								color: TextColors.OPPOSITE_PRIMARY
							}}
							_active={{
								bg: BgColors.OPPOSITE_Z2,
								color: TextColors.OPPOSITE_PRIMARY
							}}
							_disabled={{
								bg: BgColors.OPPOSITE_Z2,
								cursor: 'not-allowed'
							}}
						>
							{buttonText}
						</Button>
					)
				}
			})}
		</>
	)
}
